import { CheckboxGroup } from '@vtex/admin-ui'

import { useIntl } from 'react-intl'
import { DefaultProps } from 'typings'
import { messages } from '../messages'
import { styles } from '../styles'
import { GroupLabel } from '../../../../GroupLabel'

export function Filters(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <CheckboxGroup
      label={<GroupLabel>{$t(messages.editor.filter)}</GroupLabel>}
      className={styles.filters}
    >
      {children}
    </CheckboxGroup>
  )
}
